import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, mergeMap, takeUntil } from 'rxjs/operators';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';

import { liveQuoteTradeApiConnector } from '../../../apiConnector/secondary-market/live/trade';
import { getTabRemoved$ } from '../utils';

export function amendLiveTradeEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient, frontLogger }) => {
    const { amendTrade } = liveQuoteTradeApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_AMEND_REQUESTED'),
      mergeMap(({ tabId, etag, request }) => {
        return amendTrade(etag, request).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          mergeMap(response => of(liveThunks.amendReceivedThunk(tabId, response))),
          catchError((error: HttpError) => {
            frontLogger.error('An error occurred inside amendOrderEpic {@FrontError}', error);
            return of(liveThunks.amendFailedThunk(tabId, error));
          }),
        );
      }),
    );
  };
}
